module.exports = __webpack_public_path__ + "724b672aca4b76d26f4a60f8680d79ed.pdf";